import styled from '@emotion/styled'

const TooltipText = styled.div`
  white-space: nowrap;
  padding: 8px;
  text-align: center;
  font-size: 12px;
`

export default TooltipText
